import styled, { css } from "styled-components";
import { media } from "../../../../../layouts/utils";
//import { Button as VeloeButton } from "veloe-ds";
import { isIOS, isMacOs } from "react-device-detect";

export const Container = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
  filter: ${({ blur }) => (blur ? "blur(2px)" : "")};
  user-select: ${({ blur }) => (blur ? "none" : "auto")};

  @media(max-width: 767px) {
    gap: 20px;
  }

  .botoesCupons {
    display: flex;
    gap: 1.5rem;
    ${media.phone`
			flex-direction: column !important;
 		`}
  }
`;
export const Terms = styled.div`
	display: flex;
	gap: 0.875rem;
	color: #230C87;
	font-size: 1rem;
	margin-top: 1rem;

	b {
		text-decoration: underline;
		user-select: none;
		cursor: pointer;
		transition: all 0.3s ease-in-out;
		&:hover {
			filter: brightness(1.2);
		}
	}

	label {
		color: ${({ isChecked }) => isChecked ? '#230C87' : '#979797'};
		font-family: "Work Sans";
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;

		b {
			font-weight: 600;
			text-decoration-line: underline;
		}
	}

	${media.phone`
		font-size: 0.875rem;
		margin: 0.5rem;
		gap: 1.85rem;
		align-items: baseline;

		.container.calibri {
			width: 30px;
		}
 	`}
`

export const SmallText = styled(Terms)`
  font-size: 14px;
  font-weight: 500;
  font-family: "Platform Web";

  @media(max-width: 767px) {
    padding: 0;
  }

  p {
    color: #7B7B7A;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin: 0;

    @media(max-width: 767px) {
      line-height: 20px;
    }
  }
`;

export const Link = styled.a`
  text-decoration: none;
  ${({ disabled }) => disabled && `cursor: not-allowed; pointer-events: none;`}
`;

export const ModalHeader = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  width: 100%;
  height: 40px;
`;

export const CloseButton = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    filter: brightness(2);
  }
`;

export const Line = styled.p`
  margin-bottom: 0.75rem;
  font-weight: 100;

  .bold {
    font-weight: bold;
  }
  .italic {
    font-style: italic;
  }
  .underline {
    text-decoration: underline;
  }
  .strike {
    text-decoration: line-through;
  }
`;
export const TextBlock = styled.span`
  font-weight: 400;
  &.underline {
    text-decoration: underline;
  }
  &.bold {
    font-weight: bold;
  }
  &.italic {
    font-style: italic;
  }
`;

export const ContainerCTA = styled.div`
  ${media.desktop`
    display: block;
    button {
      width: 100%;
    }
  `}
  display: inline;
`;

export const CustomButton = styled.button`
  font-family: "Work Sans" !important;
  font-weight: 700;
  ${({ disabled }) =>
    disabled
      ? css`
          cursor: not-allowed !important;
          opacity: 0.6 !important;
          color: ${({ color }) => color} !important;
          background: ${({ backgroundColor }) => backgroundColor} !important;
        `
      : css`
          cursor: pointer;
          color: ${({ color }) => color} !important;
          background: ${({ backgroundColor }) => backgroundColor} !important;
        `};

  .label {
    ${(isIOS || isMacOs) &&
      `
      top: 0;
    `}
  }
  ${media.phone`
    width: 134px !important;
`}
  ${media.smallPhone`
  width: 134px !important;
  `}
`;

export const Button = styled.div`
  display: flex;
  padding: 17px 32px;
  justify-content: center;
  align-items: center;

  font-family: "Work Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: 1px solid transparent;
  color: ${({ color }) => color};
  border-radius: 100px;
  background: ${({ background }) => background};
  transition: all 0.5s;
	${({ disabled }) => disabled &&`
		opacity: 0.5;
	`}

  &:hover {
    border-color: #fff;
    color: #fff;
    background: #0E1E64;
  }
`